// extracted by mini-css-extract-plugin
export default {"counter__content__wrapper":"CounterContent_counter__content__wrapper__aMEbg"};